import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
//@MUI
import { Modal } from "@material-ui/core";
//@API
import { fdelete, fget, fpost, fpostBFF } from "./../../../API/callsAPI";

//@css
import useStyles from "./AssetsOverview.styles";

//@Components
import { MovieColabContext } from "../../../Context/MovieColabContext";
import NoData from "../../../Pages/InformativeComponents/NoData.component";
import { selectAppliedFilterForTrackable } from "../../../redux/selectors/projectFilters";
import CSVImportModal from "../../Utilities/CSVImportModal/CSVImportModal";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component";
import { mapFieldsFromConfig } from "../../Utilities/CustomTableForAllTrackables/fieldMapper.js";
import EditTableViewModal from "../../Utilities/EditTableViewModal/EditTableViewModal";
import ErrorOrSuccessMessage from "../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import ExportModal from "../../Utilities/ExportModal/ExportModal";
import Loader from "../../Utilities/Loader/Loader";
import NewDataLoadingLoader from "../../Utilities/NewDataLoadingLoader/NewDataLoadingLoader.component";
import NoFileFoundModal from "../../Utilities/NoFileFoundModal/NoFileFoundModal";
import { checkImage } from "../../utils";
import AssetsPageNewAssetModal from "../AssetsPageModal/AssetsPageNewAssetModal";
import AssetsTools from "../AssetsPageTool/AssetsPageTool.component";
import AssetCustomTable from "../AssetTable/AssetCustomTable.jsx";
import AssetDefaultTable from "../AssetTable/AssetDefaultTable.jsx";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component.jsx";
import AssetsPageEditAssetModal from "../AssetsPageModal/AssetsPageEditAssetModal.jsx";

function AssetsOverview(props) {
  const classes = useStyles();
  const history = useHistory();
  const tableRef = useRef();
  const hadAppliedFilterRef = useRef(false);
  const { trackableClass } = useContext(MovieColabContext);
  const assetTrackableId = trackableClass?.find(
    (trackable) => trackable.model?.toLowerCase() === "asset",
  )?.id;
  const appliedFilter = useSelector((state) =>
    selectAppliedFilterForTrackable(state, assetTrackableId),
  );
  const appliedFilterIds = appliedFilter?.id != null ? [appliedFilter.id] : [];
  const appliedFilterKey = appliedFilter
    ? `${appliedFilter.id}:${JSON.stringify(appliedFilter.filters ?? [])}`
    : "";

  const [isNewAssetModalOpen, setNewAssetModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [sortByDefault, setSortByDefault] = useState("");
  const [assetType, setAssetType] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [assetList, setAssetList] = useState();
  const [sliderState, setSliderState] = useState(0);
  const [assetFilterStatus, setAssetFilterStatus] = useState("");
  const [assetFilterType, setAssetFilterType] = useState("");
  const [departments, setDepartments] = useState([]);
  const [allUsers, setAllUsers] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [isAssetTogglerOn, setIsAssetTogglerOn] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0); //state that handles refresh counter
  const [signedUrl, setSignedUrl] = useState("");
  const [dragScreen, setDragScreen] = useState(false);
  //state will be true when we start drag file inside modals
  const [dragFileEnterModal, setDragFileEnterModal] = useState(false);
  const [scrollValue, setScrollValue] = useState("");
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);
  const [assetStats, setAssetStats] = useState({ total: 0, visibleCount: 0 });
  const [isEditAssetTableModalOpen, setIsEditAssetTableModalOpen] =
    useState(false);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [isNewPageLoading, setIsNewPageLoading] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [openBulkImportModal, setOpenBulkImportModal] = useState(false);
  const [allFieldsConfig, setAllFieldsConfig] = useState([]);
  const [isToggleView, setIsToggleView] = useState(false);
  const [isEditAssetModalOpen, setEditAssetModalOpen] = useState({
    open: false,
    data: null
  });
  const [isDeleteAssetModalOpen, setDeleteAssetModalOpen] = useState({
    open: false,
    data: null
  });

  const decodedURL = decodeURIComponent(
    escape(window.atob(history.location.search.substring(1))),
  );
  let searchParams = new URLSearchParams(decodedURL);

  useEffect(() => {
    fetchAssetType();
    fetchAsset();
    setAssetFilterType(searchParams.get("type") || "");
    setAssetFilterStatus(searchParams.get("status") || "");
    setSortByDefault(searchParams.get("sortBy") || "A-Z");
    var scrollStored = JSON.parse(localStorage.getItem("scroll"));
    if (scrollStored) {
      setScrollValue(scrollStored.asset);
    } else {
      const scrollData = {
        asset: "0",
        assetVersion: "0",
        sequence: "0",
        shots: "0",
        shotVersion: "0",
      };
      localStorage.setItem("scroll", JSON.stringify(scrollData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //add refreshCounter to dep array so when it chnges the functions will be called

  const updateRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  /** Handles state of modal */
  const handleNewAssetModalState = ({ closeFlag } = {}) => {
    setNewAssetModalOpen(!isNewAssetModalOpen);
  };

  const handleAssetToggler = () => {
    setIsAssetTogglerOn(!isAssetTogglerOn);
  };

  //Fetch status types
  const fetchAssetType = async () => {
    try {
      const assetTypeRes = await fget({
        url: `trackables/asset-type-choices/`,
      });
      setAssetType(assetTypeRes.data.asset_type_choices);
    } catch (error) {
      console.log(error);
    }
  };

  // @fetches assets list from bff at initial mount
  const fetchAsset = async () => {
    let asset = {
      url: "web/asset/list/",
      data: {
        project_id: props.params.projectId,
      },
    };
    try {
      const fetchAssetRes = await fpostBFF(asset);
      if (
        (searchParams.get("type") === null &&
          searchParams.get("status") === null) ||
        (searchParams.get("type")?.length === 0 &&
          searchParams.get("status")?.length === 0)
      ) {
        if (fetchAssetRes.data.asset_list.detail) {
          console.log(fetchAssetRes.data.asset_list.detail); //handle error here
        } else {
          setIsLoaded(true);
        }
      }
      setStatusList(fetchAssetRes?.data?.status_list?.results);
      setAssetStats((prevData) => ({
        ...prevData,
        visibleCount: fetchAssetRes.data.asset_list.count,
      }));
      setAllUsers(fetchAssetRes.data.project_users.results);
      if (fetchAssetRes.data.department_list.detail) {
        console.log(fetchAssetRes.data.department_list.detail); //handle error here
      } else {
        setDepartments(
          fetchAssetRes.data.department_list.results.map((el) => {
            const data = {
              title: el.name,
              id: el.id,
            };
            return data;
          }),
        );
      }
      window.scrollTo(0, sessionStorage.getItem("scrollpos"));
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: "Error On Loading Assets",
        isError: true,
      });
      setIsLoaded(true);
    }
  };

  const getAssetStats = async () => {
    try {
      const assetRes = await fget({
        url: `trackables/trackable-count/asset/${props.params.projectId}/`,
      });
      setAssetStats((prevData) => ({
        ...prevData,
        total: assetRes.data.instances,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      props.params.projectId ||
      parseInt(assetFilterStatus) > 0 ||
      assetFilterType.length ||
      updateOnPageChange ||
      refreshCounter
    ) {
      fetchFilteredAsset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    appliedFilterKey,
    props.params.projectId,
    assetFilterStatus,
    assetFilterType,
    currentPage,
    updateOnPageChange,
    refreshCounter,
  ]);

  useEffect(() => {
    getAssetStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCounter]);

  const fetchFilteredAsset = async (isStatusClear) => {
    if (isStatusClear) {
      setAssetFilterStatus("");
    }
    let url = `trackables/asset/v2/?page=${currentPage}&project=${props.params.projectId}`;
    if (sortByDefault) {
      url += `&sortBy=${sortByDefault}`;
    }
    try {
      if (assetFilterType) {
        url += `&type=${assetFilterType}`;
      }
      if (assetFilterStatus) {
        url += `&status=${isStatusClear ? "" : assetFilterStatus}`;
      }
      appliedFilterIds.forEach((filterId) => {
        url += `&filter=${filterId}`;
      });
      const res = await fget({ url });
      setAssetList(res.data);
      setIsLoaded(true);
      setIsNewPageLoading(false);
    } catch (error) {
      setIsNewPageLoading(false);
      console.error("Error loading filtered assets", error);
    }
    history.push("?" + btoa(unescape(encodeURIComponent(url.split("?")[1]))));
  };

  async function fetchFile(id) {
    if (id) {
      // fetching the signed url only if file is there

      try {
        const res = await fget({
          url: `trackables/asset/${id}/file`,
        });
        setSignedUrl(res.data.signed_url);
      } catch (error) {
        setSignedUrl("");
        console.log(error);
      }
    } else setSignedUrl("");
  }

  useEffect(() => {
    assetList?.results &&
      searchParams.get("sortBy") &&
      handleSubmitSort(searchParams.get("sortBy"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetList]);

  //Function to sort Assets
  function handleSubmitSort(sortBy) {
    searchParams.set("sortBy", `${sortBy}`);
    history.push(
      "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
    );
    switch (sortBy) {
      case "A-Z":
        assetList?.results?.sort((a, b) => a.name.localeCompare(b.name));
        setSortByDefault("A-Z");
        break;
      case "Z-A":
        assetList?.results?.sort((a, b) => b.name.localeCompare(a.name));
        setSortByDefault("Z-A");
        break;
      case "LatestModified":
        assetList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateB - dateA;
        });
        setSortByDefault("LatestModified");
        break;
      case "LastModified":
        assetList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateA - dateB;
        });
        setSortByDefault("LastModified");
        break;
      case "DateCreated":
        assetList?.results?.sort(function (a, b) {
          var dateA = new Date(a.created_at),
            dateB = new Date(b.created_at);
          return dateA - dateB;
        });
        setSortByDefault("DateCreated");
        break;
      default:
        return assetList?.results;
    }
  }

  const handleDragFile = (e) => {
    setDragScreen(true);
    if (e.type === "drop") {
      //if we drop file , removing drag zone screen
      setDragScreen(false);
    }
    if (e.type === "dragleave") {
      //if we leave the drag file , removing drag zone screen
      if (dragFileEnterModal) {
        setDragScreen(true);
      } else {
        setDragScreen(false);
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragScreen = (el) => {
    setDragScreen(el);
  };

  let scrollTimer = null;
  const handleTableScroll = (e) => {
    if (scrollTimer !== null) clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      searchParams.set("scroll", `${e.target.scrollTop}`);
      history.replace(
        "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
      );
      let scrollStored = JSON.parse(localStorage.getItem("scroll"));
      scrollStored.asset = e.target.scrollTop;
      localStorage.setItem("scroll", JSON.stringify(scrollStored));
    }, 700);
  };

  const fetchAllAssetData = async () => {
    const PAGE_SIZE = 50;
    const firstRes = await fget({
      url: `trackables/asset/?page=1&project=${props.params.projectId}&type=${assetFilterType}&status=${assetFilterStatus}`,
    });
    const totalCount = firstRes.data.count;
    const totalPages = Math.ceil(totalCount / PAGE_SIZE);

    if (totalPages <= 1) {
      return firstRes.data.results;
    }

    const remainingPromises = Array.from({ length: totalPages - 1 }, (_, i) =>
      fget({
        url: `trackables/asset/?page=${i + 2}&project=${props.params.projectId}&type=${assetFilterType}&status=${assetFilterStatus}`,
      }),
    );
    const remainingResults = await Promise.all(remainingPromises);

    return [
      ...firstRes.data.results,
      ...remainingResults.flatMap((res) => res.data.results),
    ];
  };

  const createAssetInBulk = async (
    tableData,
    columnMappings,
    trackableType,
    defaultFields = [],
  ) => {
    const validApiFields = new Set(defaultFields.map((f) => f.name));
    //add project_id to the data
    const assets = tableData.map((row) =>
      Object.fromEntries(
        Object.entries(columnMappings)
          .filter(
            ([, apiField]) =>
              apiField && apiField !== "none" && validApiFields.has(apiField),
          )
          .map(([csvHeader, apiField]) => [apiField, row[csvHeader]]),
      ),
    );
    assets.forEach((asset) => {
      asset.project = props.params.projectId;
    });
    try {
      const res = await fpost({
        url: `trackables/asset/v2/`,
        data: assets,
      });
      if (res.status === 200 || res.status === 201) {
        setSnackValue({
          isOpen: true,
          message: "Assets imported successfully",
          isError: false,
        });
        updateRefreshCounter();
        return true;
      }
      return false;
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: error.response.data.detail || "Error importing assets",
        isError: true,
      });
      console.log(error);
      return false;
    }
  };

  function handleEditAssetModalState(e, data) {
    e?.stopPropagation();
    setEditAssetModalOpen({
      open: true,
      data: data
    });
  }

  function handleDeleteAssetModalState(e, data) {
    e?.stopPropagation();
    setDeleteAssetModalOpen({
      open: true,
      data: data
    });
  }

  const handleDeleteAsset = async () => {
    try {
      await fdelete({
        url: `trackables/asset/${isDeleteAssetModalOpen.data?.id}/`,
      });
      updateRefreshCounter();
      setDeleteAssetModalOpen({
        open: false,
        data: null
      });
      setEditAssetModalOpen({
        open: false,
        data: null
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (assetList && assetList.count !== 0) {
      const fields = mapFieldsFromConfig(
        assetList.fields_config,
        assetList.custom_fields,
        assetList.default_fields,
      );
      setAllFieldsConfig(fields);
    }
  }, [assetList]);

  return (
    <div
      className={classes.root}
      onDragEnter={(e) => handleDragFile(e)}
      onDrop={(e) => handleDragFile(e)}
      onDragLeave={(e) => handleDragFile(e)}
      onDragOver={(e) => handleDragFile(e)}
    >
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <AssetsTools
        openNewAssetModal={handleNewAssetModalState}
        status={statusList}
        assetType={assetType}
        handleSliderChange={(value) => {
          setSliderState(value);
          sessionStorage.setItem("sliderState", `${sliderState}`);
        }}
        sliderState={sliderState}
        handleStatusChange={(value) => {
          if (value.length === 0) {
            fetchFilteredAsset(true);
          } else setAssetFilterStatus(value);
        }}
        handleTypeChange={(value) => {
          if (assetFilterStatus === "" && value === "") {
            history.replace(history.location.pathname);
            window.location.reload();
          } else setAssetFilterType(value);
        }}
        filterValues={{ status: assetFilterStatus, type: assetFilterType }}
        handleAssetToggler={handleAssetToggler}
        onSubmit={handleSubmitSort}
        defaultvalue={sortByDefault}
        assetStats={assetStats}
        handleOpenEditViewModal={() => setIsEditAssetTableModalOpen(true)}
        handleOpenExportModal={() => setIsExportModalOpen(true)}
        handleOpenBulkImportModal={() => setOpenBulkImportModal(true)}
        projectId={props.params.projectId}
        isToggleView={isToggleView}
        handleToggleView={() => setIsToggleView(!isToggleView)}
      />
      {!isLoaded && <Loader />}
      {isLoaded && assetList && assetList.count === 0 && <NoData />}
      {isLoaded && assetList && assetList.count > 0 && (
        <>
          {isToggleView ? (
            <AssetCustomTable
              assetList={assetList}
              assetType={assetType}
              projectId={props.params.projectId}
              statusList={statusList}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              setSnackValue={setSnackValue}
              allFieldsConfig={allFieldsConfig}
              handleTableScroll={handleTableScroll}
              handleEditAssetModalState={handleEditAssetModalState}
            />
          ) : (
            <AssetDefaultTable
              assetList={assetList}
              assetType={assetType}
              projectId={props.params.projectId}
              statusList={statusList}
              isToggleView={isToggleView}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              handleTableScroll={handleTableScroll}
              tableRef={tableRef}
              scrollValue={scrollValue}
              isAssetTogglerOn={isAssetTogglerOn}
              handleEditAssetModalState={handleEditAssetModalState}
            />
          )}
          {assetList.count > 50 && (
            <footer style={{ bottom: "0", height: "100%" }}>
              <div>
                <CustomPagination
                  handlePageChange={handlePageChange}
                  currentPage={currentPage}
                  totalItem={assetList.count}
                  totalPage={Math.ceil(assetList.count / 50)}
                  setIsNewPageLoading={setIsNewPageLoading}
                  trackable="Assets"
                />
              </div>
            </footer>
          )}
        </>
      )}
      <Modal className={classes.assetsPageModals} open={isNewPageLoading}>
        <NewDataLoadingLoader trackable="Assets" />
      </Modal>

      <Modal
        className={classes.assetsPageModals}
        open={isNewAssetModalOpen}
        onClose={() => setNewAssetModalOpen(false)}
      >
        <AssetsPageNewAssetModal
          users={allUsers}
          status={statusList}
          assetType={assetType}
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          departments={departments}
          projectId={props.params.projectId}
          handleNewAssetModal={handleNewAssetModalState}
          updateRefreshCounter={updateRefreshCounter}
          customFields={assetList?.custom_fields}
        />
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={isViewModalOpen}
        onClose={() => {
          setIsViewModalOpen(false);
        }}
      >
        {signedUrl ? (
          checkImage(signedUrl) ? (
            <img
              src={signedUrl}
              className="card-img-top"
              style={{ width: "500px", height: "auto" }}
              alt="asset"
            />
          ) : (
            <video
              src={signedUrl}
              controls
              autoPlay
              style={{ width: "auto", height: "500px" }}
            />
          )
        ) : (
          <NoFileFoundModal
            handleClose={() => {
              setIsViewModalOpen(false);
            }}
          />
        )}
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={isEditAssetTableModalOpen}
        onClose={() => {
          setIsEditAssetTableModalOpen(false);
        }}
      >
        <EditTableViewModal
          type="new"
          projectId={props?.projectId}
          handleClose={() => setIsEditAssetTableModalOpen(false)}
        />
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={openBulkImportModal}
        onClose={() => setOpenBulkImportModal(false)}
      >
        <CSVImportModal
          createInBulk={createAssetInBulk}
          trackableType="asset"
          closeModal={() => setOpenBulkImportModal(false)}
          projectId={props.params.projectId}
          requiredFields={["name", "type"]}
        />
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={isExportModalOpen}
        onClose={() => {
          setIsExportModalOpen(false);
        }}
      >
        <ExportModal
          headersList={[
            "Asset Name",
            "Description",
            "Type",
            "Status",
            "Last Modified",
            "Departments",
          ]}
          valuesList={[
            { name: "name", type: "string" },
            { name: "description", type: "string" },
            { name: "type", type: "string" },
            { name: "status", type: "object", key: "name" },
            { name: "updated_at", type: "date" },
            { name: "allowed_dept", type: "array", key: "name" },
          ]}
          fetchAllData={fetchAllAssetData}
          handleClose={() => setIsExportModalOpen(false)}
        />
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={isDeleteAssetModalOpen.open}
        onClose={() => setDeleteAssetModalOpen({
          open: false,
          data: null
        })}
      >
        <DeleteModal
          type="asset"
          name={isDeleteAssetModalOpen.data?.name}
          handleCloseDeleteModal={() => {
            setDeleteAssetModalOpen({
              open: false,
              data: null
            });
          }}
          handleDelete={handleDeleteAsset}
        />
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={isEditAssetModalOpen.open}
        onClose={() => setEditAssetModalOpen({
          open: false,
          data: null
        })}
      >
        <AssetsPageEditAssetModal
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          parentAsset={isEditAssetModalOpen.data}
          projectId={props.params.projectId}
          assetID={isEditAssetModalOpen.data?.id}
          assetType={assetType}
          statusList={statusList}
          handleEditAssetModal={(e) => {
            e?.stopPropagation();
            setEditAssetModalOpen({
          open: false,
          data: null
        });
          }}
          handleDeleteAssetModalState={handleDeleteAssetModalState}
          updateRefreshCounter={updateRefreshCounter}
          setSnackValue={setSnackValue}
          customFields={assetList?.custom_fields}
        />
      </Modal>
    </div>
  );
}

export default AssetsOverview;
